function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { Button } from "sprout-ui-dom/dist/Button";
import useToggle from "@sprout/hooks/dist/useToggle";
import styled from "styled-components";
import { useNavigationActiveLock } from "@sprout/list-navigation";
import { media } from "sprout-ui-theme";
import { useTopicPageViewsTopicEditor } from "./TopicPage_Views_Topic/TopicPageViewsTopicEditorContext";
import TopicPageEditorPost from "./TopicPageEditorPost";
const NewPostButton = styled(Button)`
  display: none;
  align-self: flex-start;
  margin-top: 10px;
  margin-bottom: 10px;

  ${media.up("medium", "pointer")} {
    display: inline-flex;
  }
`;
const TopicPageNewPostButton = (props)=>{
    const { topicId , explicitlyHidden  } = props;
    const { state: { editor , editorPosition , parentId  } , dispatch ,  } = useTopicPageViewsTopicEditor();
    const [open, setOpen, setClose] = useToggle(editor === "CREATE_POST" && editorPosition === Number.MIN_SAFE_INTEGER);
    useNavigationActiveLock(open);
    /**
   * TODO: Find a way to extract this component out from any components that
   * uses their `id`/`nodeId` as the key. This is because during optimistic
   * response, the component unmounts thereby causing a lot of
   * unexpected behaviors
   *
   * Why is this needed?
   * https://sprout.io/leaf/46489
   */ const closeEditor = useCallback(()=>{
        if (topicId < 0) return;
        dispatch({
            type: "CLOSE_EDITOR"
        });
        setClose();
    }, [
        dispatch,
        setClose,
        topicId
    ]);
    const showButton = !(editor === "CREATE_POST" && (editorPosition === topicId || parentId === topicId)) && !open;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TopicPageEditorPost, _objectSpread({
                open: open ? "desktop" : undefined,
                closeEditor: closeEditor
            }, props)),
            showButton && !explicitlyHidden && /*#__PURE__*/ _jsx(NewPostButton, {
                variant: "outline",
                size: "sm",
                onClick: setOpen,
                children: "Add a leaf"
            })
        ]
    });
};
export default TopicPageNewPostButton;
